import React from 'react';

import { DeviceContext } from '@/components/DeviceProvider/DeviceProvider';
import { MOBILE_DEVICES } from '@/logic/main/constants';
import { DeviceType } from '@/logic/main/types';
import { isModalForMobileEnabled } from '@/logic/main/utils';
import { GameLaunchStrategies, LaunchStrategyEnum } from '@/types/gameTypes';
import { isHybrid888 } from '@/utils/isHybrid888';
import get from '@/utils/lodash-alternatives';

import {
  DEFAULT_GAME_STRATEGY,
  LaunchStrategiesContext,
} from './LaunchStrategiesProvider';

//TODO gameLaunchStrategies are in both LaunchStrategiesContext and main xState context...duplication and problems creator...
export const getLaunchStrategyByParams = (
  integration: string,
  launchStrategies: GameLaunchStrategies | LaunchStrategyEnum[]
) => get(launchStrategies, integration, DEFAULT_GAME_STRATEGY);

export function GetGameLaunchStrategy(
  integration: string
): LaunchStrategyEnum | 'default' {
  const { launchStrategies } = React.useContext(LaunchStrategiesContext);
  return getLaunchStrategyByParams(integration, launchStrategies);
}

export function shouldUseModalForMobile(
  deviceType: DeviceType,
  launchStrategy: LaunchStrategyEnum
) {
  return (
    isModalForMobileEnabled &&
    MOBILE_DEVICES.includes(deviceType) &&
    launchStrategy === LaunchStrategyEnum.modalForMobile
  );
}

/**
 * Determines whether to prevent the default click behavior based on the integration, deviceType, isNative and launchStrategy.
 * @param integration The integration string to check.
 * @returns True if the default click behavior should be prevented, false otherwise.
 */
export function ShouldPreventDefaultForClick(integration?: string): boolean {
  const { launchStrategies, callbackMode } = React.useContext(
    LaunchStrategiesContext
  );
  const { deviceType, deviceNative: isNative } = React.useContext(
    DeviceContext
  );

  if (!integration) return callbackMode === 'event';
  // At this point we assume game launch is happening

  // Always prevent default for Hybrid 888 app
  if (isHybrid888()) return true;

  const launchStrategy = getLaunchStrategyByParams(
    integration,
    launchStrategies
  );

  if (!isNative) {
    // For strategy "ModalForMobile" always prevent default
    if (shouldUseModalForMobile(deviceType, launchStrategy)) return true;
    // On desktop devices, do not prevent default for newWindow launch strategy
    if (deviceType === 'desktop' && launchStrategy === LaunchStrategyEnum.newWindow) return false;
  }

  // for XSELL variant callbackMode === 'native', that is why it will not prevent default
  return callbackMode === 'event';
}
